module.exports = __webpack_public_path__ + "img/lunas.58acbe39.png";